import pegasus from '../01-pegasus';
export default class AtrApp {
    activeMenuItem = false;
    subMenuOpen = false;
    atTop = true;
    nightMode = pegasus.getCookie('nightMode');
    currency = pegasus.getCookie('currency');
    openCurrencySelector = false;
    locationIndex = pegasus.getCookie('locationIndex');

    init() {
        if (!this.locationIndex) {
            this.locationIndex = 'USD';
        }

        window.addEventListener('scroll', () => {
            this.atTop = window.scrollY < 200;
        });

        
        this.initTwoColumnBody();
        
        document.addEventListener("DOMContentLoaded", () => {
            this.replaceBrWithSpace();
            this.initExploreButton();
            this.initExploreLinks();
        });

        pegasus.onResizeFinished(() => {
            this.replaceBrWithSpace();
        }, true);
    }

    toggleNightMode() {
        this.nightMode = this.nightMode === '1' ? '0' : '1';
        pegasus.setCookie('nightMode', this.nightMode, 60);
    }

    toggleCurrency(e) {
        this.currency = e.target.dataset.index;
        pegasus.setCookie('currency', this.currency, 60);
    }

    toggleLocation(e) {
        this.locationIndex = e.target.dataset.index;
        pegasus.setCookie('locationIndex', this.locationIndex, 60);
    }

    initExploreButton() {
        // Select all a tags that include /explore/ somewhere in the href
        const links = document.querySelectorAll('a[href*="/explore/"], a[href*="/explore-"]');
        links.forEach(link => {
            link.addEventListener('click', () => {
                pegasus.deleteCookie('lastExplorePage');
                pegasus.setCookie('lastExplorePage', link.href, 1);

                // Ignore the click event if the current window href includes /explore-* or /explore/
                if (window.location.href.includes('/explore-') || window.location.href.includes('/explore/')) {
                    return;
                }

                pegasus.deleteCookie('lastPage');
                pegasus.setCookie('lastPage', window.location.href, 1);
            });
        });
    }

    initExploreLinks() {
        const allExploreLinks = document.querySelectorAll('a[href$="/explore/"]');
        allExploreLinks.forEach(link => {
            if (link.dataset.pegasusExplore === 'sentence') {
                if (pegasus.getCookie('lastSentencePage')) {
                    link.href = pegasus.getCookie('lastSentencePage');
                }
            } else if (pegasus.getCookie('lastExplorePage')) {
                link.href = pegasus.getCookie('lastExplorePage');
            }
        });
    }

    initTwoColumnBody() {
        const columns = document.querySelectorAll('.wp-block-columns');

        columns.forEach(column => {
            const columnChildren = column.children;
            const columnCount = columnChildren.length;

            if (columnCount != 2) {
                return;
            }

            // Check if either of the 2 columns has a child that is a .wp-block-heading
            const hasHeading = Array.from(columnChildren).some(child => child.querySelector('.wp-block-heading'));

            if (!hasHeading) {
                return;
            }

            column.classList.add('two-column-body');
        });

        const twoColumnBodies = document.querySelectorAll('.two-column-body');

        twoColumnBodies.forEach(twoColumnBody => {

            const height = twoColumnBody.offsetHeight;

            if(height > 1000) {
                twoColumnBody.classList.add('in-view');
                return;
            }
            
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        twoColumnBody.classList.add('in-view');
                    }
                });
            }, {
                threshold: 0.15
            });

            observer.observe(twoColumnBody);

        });
    }

    replaceBrWithSpace() {
        if (window.innerWidth >= 768) {
            return;
        }
        document.querySelectorAll(".two-column-body .wp-block-heading.heading-two br").forEach(br => {
            br.replaceWith(" ");
        });
    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('atrApp', () => new AtrApp());
});